<template>
    <div :class="{'container-dark': theme_dark}">
      <div class="nav-top">
        <div class="nav-left" @click="back()">
          <img src="../../assets/img/返回箭头.png" class="nav-img" />
          <span class="nav-lable"></span>
        </div>
        <div class="nav-middle">夜间模式</div>
        <div class="nav-right">
          <span class="nav-lable"></span>
          <img src="../../assets/img/返回箭头.png" class="nav-img none" />
        </div>
      </div>
  
      <div class="menu-block">
        <div class="ub ub-pc menu-item">
          <div class="ub-ae ub-f1 menu-item-name">夜间模式</div>
          <label class="switch">
            <input type="checkbox" v-model="theme_dark" @change="change()" />
            <div class="slider round"></div>
          </label>
        </div>
        <div class="menu-line"></div>
      </div>
    </div>
  </template>
  
  <script>
  import * as tool from "../../api/common";
  import { mapMutations, mapActions } from "vuex";
  
  export default {
    data() {
      return {
        theme_dark: false
      };
    },
    mounted() {
      this.init_page();
    },
    methods: {
      ...mapMutations(["get", "post"]), //引入方法
      back() {
        this.$router.go(-1); //返回上一层
      },
      init_page() {
        //切换深色模式
        this.theme_dark = tool.is_theme_dark(this);
      },
      change() {
        this.theme_dark = !this.theme_dark;
        if (this.theme_dark) {
          this.$store.commit('set_objVal', {"theme_dark" : false});
          this.theme_dark = false;
          this.$toast.top("已关闭");
        } else {
          this.$store.commit('set_objVal', {"theme_dark" : true});
          this.$toast.top("已开启");
        }
        this.init_page();
      }
    },
  };
  </script>
  
  
  <style lang="scss" scoped>
  .menu-block {
    padding: 0 1.2rem 0 .8rem;
    background-color: #fff;
    .menu-item {
      height: 3rem;
      .menu-item-name{
        font-size: .95rem;
      }
      .switch {
        position: relative;
        display: inline-block;
        width: 3.2rem;
        height: 1.8rem;
        input {
          display: none;
          outline: 0;
        }
        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 3.5rem;
          height: 1.8rem;
          background-color: #fdfdfd;
          transition: 0.1s;
          border: 2px solid #dcdcdc;
          user-select: none;
          border-radius: 1.1rem;
          outline-style: none;
          border: 1px solid #ddd;
          text-shadow: none;
          -webkit-appearance: none;
          -webkit-user-select: text;
          -webkit-tap-highlight-color:rgba(0,0,0,0);
        }
        
        
        .slider:before {
          position: absolute;
          content: "";
          height: 1.8rem;
          width: 1.8rem;
          background-color: white;
          transition: 0.1s;
          box-shadow: 0px 0.1px 2px #EEEEEE;
          border-radius: 50%;
        }
        input:checked + .slider {
          background-color: #45db5e;
        }
        input:checked + .slider:before {
          transform: translateX(1.7rem);
        }
      }
    }
  }
  
  .container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .menu-block {
    background-color: #2c2b30;
    .menu-item-name {
      color: #DFDFDF;
    }
  }
  .menu-line {
    border-top: 1px solid #404040;
  }
}
  </style>
  